import {Key, pathToRegexp} from "path-to-regexp";

import {identity, pickBy} from "@pg-mono/nodash";

import {promotionUrlConstants} from "./promotion_url_constants";
import {PromotionType} from "./PromotionType";

const typeRegex = ":type(oferty-promocyjne|dni-otwarte|przeceny|last-minute|przedsprzedaz|targi-mieszkaniowe|bez-wkladu-wlasnego|^$)?";
const beforeRegionDashRegex = ":beforeRegionDash(-)?";
const regionRegex = ":region(.*?)";

export const promotionListRegex = `${typeRegex}${beforeRegionDashRegex}${regionRegex}`;

export interface IPromotionSlugParsed {
    region: string | number;
    type: PromotionType;
}

export const parsePromotionRegionPathToSlug = (regionPathSegments: string[]): string => {
    if (regionPathSegments.length === 0) {
        return "";
    }

    if (regionPathSegments.length === 1) {
        return regionPathSegments[0];
    }

    return `${regionPathSegments[0]}-${regionPathSegments.slice(1).join("-")}`;
};

const parseSlashPromotionUrl = (url: string): Partial<IPromotionSlugParsed> | null => {
    const segments = url.split("/").filter(Boolean);

    if (segments.length === 0) {
        return null;
    }

    const parsedType = promotionUrlConstants.types[segments[0]];

    if (parsedType !== undefined) {
        const regionSegments = segments.slice(1);

        return pickBy(
            {
                region: regionSegments.length > 0 ? parsePromotionRegionPathToSlug(regionSegments) : undefined,
                type: parsedType
            },
            identity
        );
    }

    return pickBy(
        {
            region: parsePromotionRegionPathToSlug(segments)
        },
        identity
    );
};

const parseLegacyHyphenPromotionUrl = (url: string): Partial<IPromotionSlugParsed> | null => {
    const keys: Key[] = [];
    const regexp = pathToRegexp(promotionListRegex, keys);
    const regExpExecArray: RegExpExecArray | null = regexp.exec(url);

    if (regExpExecArray == null) {
        return null;
    }

    const values: Record<string, string | number> = {
        region: regExpExecArray[3],
        type: promotionUrlConstants.types[regExpExecArray[1]]
    };

    return pickBy(values, identity);
};

export const promotionUrlParser = (url: string): Partial<IPromotionSlugParsed> | null => {
    if (url.match(/-$/gi)) {
        return null;
    }

    if (url.includes("/")) {
        return parseSlashPromotionUrl(url);
    }

    return parseLegacyHyphenPromotionUrl(url);
};
import {Key, pathToRegexp} from "path-to-regexp";

import {identity, pickBy} from "@pg-mono/nodash";

import {promotionUrlConstants} from "./promotion_url_constants";
import {PromotionType} from "./PromotionType";

const typeRegex = ":type(oferty-promocyjne|dni-otwarte|przeceny|last-minute|przedsprzedaz|targi-mieszkaniowe|bez-wkladu-wlasnego|^$)?";
const beforeRegionDashRegex = ":beforeRegionDash(-)?";
const regionRegex = ":region(.*?)";

export const promotionListRegex = `${typeRegex}${beforeRegionDashRegex}${regionRegex}`;

export interface IPromotionSlugParsed {
    region: string | number;
    type: PromotionType;
}

export const parsePromotionRegionPathToSlug = (regionPathSegments: string[]): string => {
    if (regionPathSegments.length === 0) {
        return "";
    }

    if (regionPathSegments.length === 1) {
        return regionPathSegments[0];
    }

    return `${regionPathSegments[0]}-${regionPathSegments.slice(1).join("-")}`;
};

const parseSlashPromotionUrl = (url: string): Partial<IPromotionSlugParsed> | null => {
    const segments = url.split("/").filter(Boolean);

    if (segments.length === 0) {
        return null;
    }

    const parsedType = promotionUrlConstants.types[segments[0]];

    if (parsedType !== undefined) {
        const regionSegments = segments.slice(1);

        return pickBy(
            {
                region: regionSegments.length > 0 ? parsePromotionRegionPathToSlug(regionSegments) : undefined,
                type: parsedType
            },
            identity
        );
    }

    return pickBy(
        {
            region: parsePromotionRegionPathToSlug(segments)
        },
        identity
    );
};

const parseLegacyHyphenPromotionUrl = (url: string): Partial<IPromotionSlugParsed> | null => {
    const keys: Key[] = [];
    const regexp = pathToRegexp(promotionListRegex, keys);
    const regExpExecArray: RegExpExecArray | null = regexp.exec(url);

    if (regExpExecArray == null) {
        return null;
    }

    const values: Record<string, string | number> = {
        region: regExpExecArray[3],
        type: promotionUrlConstants.types[regExpExecArray[1]]
    };

    return pickBy(values, identity);
};

export const promotionUrlParser = (url: string): Partial<IPromotionSlugParsed> | null => {
    if (url.match(/-$/gi)) {
        return null;
    }

    if (url.includes("/")) {
        return parseSlashPromotionUrl(url);
    }

    return parseLegacyHyphenPromotionUrl(url);
};
